exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addres-choice-label[data-v-56ddb1e1]{border:1px solid #dedede;display:block;padding:15px;position:relative;cursor:pointer}.addres-choice-label .checkmark[data-v-56ddb1e1]{position:absolute;right:0;bottom:0;background-color:#003b77;color:#fff;padding:2px 4px}.addres-choice-label input[data-v-56ddb1e1]{display:none}.addres-choice-label.choice-active[data-v-56ddb1e1]{border-color:#003b77}.shipping_toggle[data-v-56ddb1e1]{margin-top:1em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}.default-switch[data-v-56ddb1e1]{margin-bottom:0;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-56ddb1e1","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/Components/Checkout/CheckoutAddress.vue
// module id = IZhQ
// module chunks = 0